export const locales = ['en', 'ru', 'tg'] as const
export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = 'tg'

export const localeNames: Record<Locale, string> = {
  en: 'English',
  ru: 'Русский',
  tg: 'Тоҷикӣ',
}

/** @deprecated Use localeCountryCodes + CountryFlag component instead */
export const localeFlags: Record<Locale, string> = {
  en: '🇬🇧',
  ru: '🇷🇺',
  tg: '🇹🇯',
}

/** Country codes for flag-icons CSS library */
export const localeCountryCodes: Record<Locale, string> = {
  en: 'gb',
  ru: 'ru',
  tg: 'tj',
}
